const log = require('log').create('disablescroll') // eslint-disable-line

function cropElement(el) {
    // if already cropped, return
    if (el.getAttribute('scroll-disabled')) return
    // get current scroll top
    // https://stackoverflow.com/questions/16618785/ie8-alternative-to-window-scrolly#16618863
    const top = document.documentElement.scrollTop
    // set top of first element in the layer element
    el.children[0].style.top = `-${top}px`
    // mark the element as scroll-disabled, storing value of top
    // this attribute triggers the cropping CSS in app.less
    el.setAttribute('scroll-disabled', top)
    // scroll to the top for the incoming layer
    window.scrollTo(0, 0)
}

function uncropElement(el) {
    // if not croppped, ignore
    if (! el.getAttribute('scroll-disabled')) return
    // get the stored top value
    const top = el.getAttribute('scroll-disabled')
    // uncrop the element
    el.removeAttribute('scroll-disabled')
    // remove the top position of the first child in the layer
    el.children[0].style.top = null
    // restore scroll position
    window.scrollTo(0, top)
}

const DisableScroll = {

    stack: [],

    on(element) {
        // find any exsting uncropped layer elements (usually just one)
        const cropped = (
            Array.prototype.slice.call(document.querySelectorAll('.layer'))
                .filter(el => ! el.getAttribute('scroll-disabled'))
                .filter(el => el !== element)
        )
        // crop those layers
        cropped.forEach(cropElement)
        // save this layer in the stack
        this.stack.push({
            element,
            cropped,
        })
    },

    off(element) {
        // find the layer for this element
        const layer = this.stack.filter(item => item.element === element)[0]
        if (! layer) return
        // uncrop any elements that were cropped by this layer
        layer.cropped.forEach(uncropElement)
    },

}

// only return public methods
module.exports = DisableScroll
